import React from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
export function FinalCTA() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-20 md:py-28 bg-forest px-6 text-center" data-id="element-75">
      <div className="max-w-4xl mx-auto" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-77">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-78">
            Your Financial Legacy Begins Here
          </h2>
          <p className="text-white/80 text-lg md:text-xl leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-79">
            See how an IUL insurance policy can fit into your financial plan and
            help you build tax-free retirement wealth while protecting your
            family.
          </p>

          <button onClick={scrollToContact} className="bg-cream text-forest px-8 py-4 rounded-full font-bold text-lg hover:bg-white transition-all hover:-translate-y-0.5 hover:shadow-lg inline-flex items-center gap-2" data-id="element-80">
            <Calendar size={20} data-id="element-81" />
            Schedule a Free Consultation
          </button>
        </motion.div>
      </div>
    </section>;
}